"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var Video = styled_components_1.default.video(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  outline: none;\n  display: flex;\n  height: ", ";\n  ", "\n  border-bottom: ", ";\n  border-bottom-width: thin;\n  backface-visibility: hidden;\n  max-width: ", ";\n  ", "\n\n  @media screen and (max-width: 500px) {\n    ", "\n      \n  }\n\n  &.second-video {\n    height: auto;\n    border-bottom: ", ";\n    border-bottom-width: thin;\n    backface-visibility: hidden;\n  }\n"], ["\n  width: 100%;\n  outline: none;\n  display: flex;\n  height: ", ";\n  ", "\n  border-bottom: ", ";\n  border-bottom-width: thin;\n  backface-visibility: hidden;\n  max-width: ", ";\n  ", "\n\n  @media screen and (max-width: 500px) {\n    ", "\n      \n  }\n\n  &.second-video {\n    height: auto;\n    border-bottom: ", ";\n    border-bottom-width: thin;\n    backface-visibility: hidden;\n  }\n"])), function (_a) {
    var _b = _a.embed, embed = _b === void 0 ? false : _b;
    return (embed ? '100%' : 'auto');
}, function (_a) {
    var _b = _a.isChangingToSecondVideo, isChangingToSecondVideo = _b === void 0 ? false : _b, _c = _a.secondVideoThumbnail, secondVideoThumbnail = _c === void 0 ? "" : _c, _d = _a.isInFullscreen, isInFullscreen = _d === void 0 ? false : _d;
    if (isChangingToSecondVideo) {
        return "\n        background-image: url('" + secondVideoThumbnail + "');\n        background-repeat: no-repeat;\n        background-size: contain;\n        background-position: center;\n      ";
    }
}, function (_a) {
    var _b = _a.isInFullscreen, isInFullscreen = _b === void 0 ? false : _b;
    return isInFullscreen
        ? "1px solid rgba(0, 0, 0, 0.1)"
        : "1px solid rgba(255, 255, 255, 0.1)";
}, function (_a) {
    var _b = _a.isPortrait, isPortrait = _b === void 0 ? false : _b, _c = _a.isInFullscreen, isInFullscreen = _c === void 0 ? false : _c, _d = _a.embed, embed = _d === void 0 ? false : _d;
    return !embed && isPortrait && !isInFullscreen ? "294px;" : "100%;";
}, function (_a) {
    var isInFullscreen = _a.isInFullscreen, _b = _a.isPreview, isPreview = _b === void 0 ? false : _b, _c = _a.embed, embed = _c === void 0 ? false : _c;
    return isInFullscreen || isPreview || embed ? "" : "max-height: 480px;";
}, function (_a) {
    var _b = _a.isPortrait, isPortrait = _b === void 0 ? false : _b, limit = _a.limit, _c = _a.isInFullscreen, isInFullscreen = _c === void 0 ? false : _c;
    return "max-" + limit + ": " + ((isPortrait && !isInFullscreen) ? '294px' : '100%') + ";";
}, function (_a) {
    var _b = _a.isInFullscreen, isInFullscreen = _b === void 0 ? false : _b;
    return isInFullscreen
        ? "1px solid rgba(0, 0, 0, 0.1)"
        : "1px solid rgba(255, 255, 255, 0.1)";
});
exports.default = Video;
var templateObject_1;
